<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12>
        <v-text-field v-model="quoteNo" solo single-line></v-text-field>
        <v-btn class="text-xs-right" color="success" @click.stop="fncSearchArchivedQuotes">Search Quotes</v-btn>

        <v-data-table loading="true" :headers="headers" :items="archivedQuotes" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr class="sortableRow" id="rows">
              <td width="30%">{{ props.item.quote_no }}</td>
              <td width="30%" >{{ props.item.status }}</td>
              <td width="30%" >{{ fncGetLocalizedDateFromUTC(props.item.created) }}</td>
              <td width="10%"><a @click.prevent="fncUnarchiveQuote(props.item.id)"><i class="material-icons">restore</i></a></td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>

      <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>

  </v-container>
  <!--<v-container grid-list-lg>
    <v-layout row wrap>
      <v-text-field v-model="quoteNo" solo single-line></v-text-field>
    </v-layout>
  </v-container>-->
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "Modal_clone_quote",
  data () {
    return {
      quoteNo: '',
      search: '',
      headers: [
        {text: 'Quote No', value: 'name', width: '30%'},
        {text: 'Status', value: 'description', width: '30%'},
        {text: 'Created On', value: 'created_on', width: '30%'},
        {text: 'Unarchive', value: 'delete', width: '10%'}
      ]
    }
  },
  methods: {
    fncUnarchiveQuote( id ) {
      this.$store.dispatch('fncUnarchiveQuote', id);
    },
    fncGetLocalizedDateFromUTC(theDate) {

      var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        hour12: false
      };

      var newDate = new Date(Date.parse(theDate + ' UTC'));
      var dateString = newDate.toLocaleString("en", options);
      var objDate = dateString.split(',');

      var newDate = objDate[0].split('/');

      var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

      return strDate;

    },
    fncSearchArchivedQuotes() {
      this.$store.dispatch('getArchivedQuotes', this.quoteNo);
    },
    fncHideModal() {
      // this.$store.commit('hideModal');
      window.location.reload();
    },
    fncClone()
    {
      this.$store.dispatch({
        type: 'fncCloneQuote',
        quote: this.globalModalParams.quoteData.quote,
        branch_id: this.globalModalParams.quote_id,
        customer : this.globalModalParams.customer,
        department : this.globalModalParams.departmentId,
        status : this.globalModalParams.status,
        company : this.globalModalParams.survey_company,
        project : this.globalModalParams.project
      })
    }
  },
  computed: {
    ...mapGetters([
      'archivedQuotes'
    ])
  },
  beforeMount() {
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
